import React from 'react'
import VerdictCarreBlanc from 'resources/images/app/amasis_icons/190600700.png'
import VerdictCarreGris from 'resources/images/app/amasis_icons/190600400.png'
import VerdictCarreVert from 'resources/images/app/amasis_icons/190600300.png'
import VerdictCarreOrange from 'resources/images/app/amasis_icons/190600200.png'
import VerdictCarreRouge from 'resources/images/app/amasis_icons/190600100.png'
import VerdictCarreRougeCroixNoire from 'resources/images/app/amasis_icons/190600800.png'
import VerdictCarreNoir from 'resources/images/app/amasis_icons/Noir.png'

const imgCarreName = {
  // carré blanc à considérer comme du vert
  0: VerdictCarreVert,
  // carré gris
  2: VerdictCarreGris,
  // carré vert
  4: VerdictCarreVert,
  // carré orange
  6: VerdictCarreOrange,
  // carré rouge
  8: VerdictCarreRouge,
  // carré rouge croix noire
  9: VerdictCarreRougeCroixNoire,
  // carré noir
  10: VerdictCarreNoir,
}
const Verdict = (props) => {
  const baseUrl = process.env.PUBLIC_URL

  const valVerdict = props.value
  const imgToDisplay = imgCarreName.hasOwnProperty(valVerdict) ? imgCarreName[valVerdict] : undefined

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {imgToDisplay ? <img src={imgToDisplay} className='imgVerdict' alt='verdict image' /> : ''}
    </div>
  )
}

export default Verdict
